import router from '@/router'
// 路由的query传参加密
const Base64 = {
  // 加密
  encode(str) {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(
        match,
        p1
      ) {
        return String.fromCharCode('0x' + p1)
      })
    )
  },
  // 解密
  decode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    try {
      return decodeURIComponent(
        atob(str)
          .split('')
          .map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          })
          .join('')
      )
    } catch (e) {
      router.push('/404')
      return null
    }
  }
}
export default Base64
